import {
  CountryCode,
  SegmentProps,
  ServiceFee,
  TariffAddOn,
} from 'types/generatedSchemaTypes';
import { currencyFormatter } from 'utils/commonUtils';

export const getPricesWithCurrency = ({
  totalAmount,
  serviceFee,
  parkingFee,
  parkingZoneCountryCode,
}: {
  totalAmount?: number | null;
  serviceFee?: number | null;
  parkingFee?: number | null;
  parkingZoneCountryCode?: CountryCode;
}) => {
  const formattedTotalPrice =
    totalAmount !== null && totalAmount !== undefined
      ? currencyFormatter(totalAmount, parkingZoneCountryCode)
      : null;

  const formattedServiceFee =
    serviceFee !== null && serviceFee !== undefined
      ? currencyFormatter(serviceFee, parkingZoneCountryCode)
      : null;

  const formattedParkingFee =
    parkingFee !== null && parkingFee !== undefined
      ? currencyFormatter(parkingFee, parkingZoneCountryCode)
      : null;
  return {
    totalPrice: formattedTotalPrice,
    serviceFee: formattedServiceFee,
    parkingFee: formattedParkingFee,
  };
};

export const formatServiceFeeToTextWithCurrency = (
  pricingSegments: SegmentProps[],
  activeSegmentId: string,
  parkingZoneCountryCode?: CountryCode,
  hasCorporateAccount?: boolean
) => {
  const activeSegment = pricingSegments?.find(
    (segment) => segment.uid === activeSegmentId
  );

  return formatServiceFeeConfigToTextWithCurrency(
    activeSegment?.serviceFee,
    parkingZoneCountryCode,
    hasCorporateAccount
  );
};

export const formatServiceFeeConfigToTextWithCurrency = (
  serviceFee?: ServiceFee | TariffAddOn | null,
  parkingZoneCountryCode?: CountryCode,
  hasCorporateAccount?: boolean
) => {
  const percent = serviceFee?.percent ?? 0;
  const serviceFeeMin = currencyFormatter(
    serviceFee?.amount ?? 0,
    parkingZoneCountryCode
  );
  const serviceFeeMax = currencyFormatter(
    serviceFee?.maxAmount ?? 0,
    parkingZoneCountryCode
  );

  return {
    percent,
    min: serviceFeeMin,
    max: serviceFeeMax,
    // When the user has a corporate account, the service fee is not the pricing service fee.
    // Instead, it is a transaction fee from the corporate account, and the pricing service fee
    // configuration does not affect it. Therefore, no info text should be shown.
    showServiceFeePercentInfo: hasCorporateAccount ? false : percent > 0,
  };
};
